import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { ResourceRate } from '../types/admin';

interface OrgRatesResponse {
  success: boolean;
  data: ResourceRate[];
}

export function useOrgRates(orgId: string) {
  const [rates, setRates] = useState<ResourceRate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRates = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.get<OrgRatesResponse>(`/org-admin/${orgId}/rates`);
      setRates(res.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load resource rates');
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => {
    fetchRates();
  }, [fetchRates]);

  return { rates, loading, error };
}
